export enum UserStatus {
  ACTIVE = "ACTIVE",
  INVITED = "INVITED",
  DECLINED = "DECLINED",
}
